/* Aure FAQ accordion — vanilla ES6, height-animated, event-delegated. */
(function () {
  'use strict';

  function closePanel(panel, trigger) {
    panel.style.height = panel.scrollHeight + 'px';
    requestAnimationFrame(function () {
      panel.style.height = '0px';
    });
    panel.addEventListener('transitionend', function handler() {
      panel.hidden = true;
      panel.style.height = '';
      panel.removeEventListener('transitionend', handler);
    });
    trigger.setAttribute('aria-expanded', 'false');
  }

  function openPanel(panel, trigger) {
    panel.hidden = false;
    var target = panel.scrollHeight;
    panel.style.height = '0px';
    requestAnimationFrame(function () {
      panel.style.height = target + 'px';
    });
    panel.addEventListener('transitionend', function handler() {
      panel.style.height = '';
      panel.removeEventListener('transitionend', handler);
    });
    trigger.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-aure-faq-trigger]');
    if (!trigger) return;
    var item = trigger.closest('.aure-faq__item');
    if (!item) return;
    var panel = item.querySelector('[data-aure-faq-panel]');
    if (!panel) return;

    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closePanel(panel, trigger);
    } else {
      openPanel(panel, trigger);
    }
  });

  // Ensure transition is present (panels start with height transition only when scripted)
  document.querySelectorAll('[data-aure-faq-panel]').forEach(function (p) {
    p.style.transition = 'height .28s ease';
  });
})();
